<script>
export default {
  name: 'IconLegacy',
  props: {
    iconClick: {
      type: Function,
      default: () => {},
    },
    iconSrc: {
      type: String,
      default: '',
    },
    classes: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: null,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#AAABB3',
    },
  },
};
</script>

<template>
  <div>
    <button
      type="button"
      :disabled="disable"
      :class="['cxm-IconLegacy', classes]"
      @click.prevent="iconClick"
    >
      <slot>
        <i
          :class="iconSrc"
          :style="{ 'font-size': size, color: color }"
        />
      </slot>
    </button>
  </div>
</template>

<style lang="scss" scoped>
.cxm-IconLegacy {
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  justify-content: center;
  outline: none;

  &:active {
    background: #777777;
  }

  &:hover {
    background: rgba(140, 138, 138, 0.15);
    border-radius: 5px;
  }
}
</style>
